
const PIXI = require('pixi.js');
const App = require('../app/App');
const Constants = require('../Constants');
const Shortcuts = require('../utils/Shortcuts');
const WM = require('../BOSSWatermarkSingleton');
const SizesUtils = require('../../../viscomjs/utils/SizesUtils');

const win = window;

const _init = function () {
    this._shift = 0;
    if (!(this.el.dataset && this.el.dataset.wmImage && this.el.dataset.wmImage !== 'false')) return this;

    const w = Constants.BOSSWatermarkRefWidth;
    const h = Constants.BOSSWatermarkRefHeight;
    const app = App(this.el, {
        width: w,
        height: h
    }, false, false);

    const bg = _getBG(this.el.dataset.wmImage);
    app.instance.stage.addChild(bg);


    const rect = new PIXI.Graphics();
    Shortcuts.rect(rect, -w / 2, 0, w, h, '#000');
    rect.alpha = 0.38;
    bg.addChild(rect);

    let img;
    const msks = [];
    const imgs = [];
    let msk;
    let i;
    for (i = 0; i < 3; i++) {
        img = _getIMG(this.el.dataset.wmImage);
        msk = _getMsk('bossMsk');
        img.mask = msk;
        app.instance.stage.addChild(img);
        app.instance.stage.addChild(msk);
        msks.push(msk);
        imgs.push(img);
    }

    this.app = app;
    this.stage = this.app.instance.stage;
    this.bg = bg;
    this.msks = msks;
    this.imgs = imgs;
    this.x0 = 0;
    this.delta = Constants.BOSSWatermarkPeriodRatio * h;


    win.addEventListener('resize', this._handleResize);
    this._handleResize();

    return this;
};

const _getBG = imgId => {
    const cont = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;

    const img = Shortcuts.getSprite(imgId, TextureCache, 'bg');
    img.anchor.x = 0.5;
    cont.position.x = Constants.BOSSWatermarkRefWidth / 2;
    cont.addChild(img);

    return cont;
};

const _getIMG = imgId => {
    const cont = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;

    const img = Shortcuts.getSprite(imgId, TextureCache, 'img');
    img.anchor.x = 0.5;
    img.scale.x = img.scale.y = Constants.BOSSWatermarkScale;
    cont.position.x = Constants.BOSSWatermarkRefWidth / 2;
    cont.addChild(img);

    return cont;
};

const _getMsk = imgId => {
    const TextureCache = PIXI.utils.TextureCache;
    return Shortcuts.getSprite(imgId, TextureCache, 'mskImg');
};

const _start = function () {
    if (this._started) return;
    this.app.start();
    WM.on('update', this._update);
    this._started = true;
    return this;
};


const _stop = function () {
    if (!this._started) return;
    this.app.stop();
    WM.off('update', this._update);
    this._started = false;
    return this;
};



const _update = function (progress, dx) {

    const x1 = (WM.getWrapTotalShift() + this._dX0) / this._scale;

    this.msks.forEach((msk, i) => {
        msk.x = this.x0 - dx + this.delta * i - x1;
    });

    return this;
};

const _handleResize = function () {

    const h = SizesUtils.winOffsetHeight();
    const w = SizesUtils.winOffsetWidth();
    // const sW = w / Constants.BOSSWatermarkRefWidth;
    const sH = h / Constants.BOSSWatermarkRefHeight;
    const w1 = h * Constants.BOSSWatermarkRefWidth / Constants.BOSSWatermarkRefHeight;

    const r1 = this.el.getBoundingClientRect();
    this._dX0 = r1.left - WM.getWrapTotalShift();

    let s = Math.max(1, w / w1);

    this.stage.scale.x = this.stage.scale.y = sH;

    this.bg.scale.x = this.bg.scale.y = s;
    this.bg.position.x = Math.ceil(0.5 * w / sH);

    s *= Constants.BOSSWatermarkScale;

    this.imgs.forEach(img => {
        img.scale.x = img.scale.y = s;
        img.position.x = Math.ceil(0.5 * w / sH);
    });

    this.app.instance.renderer.resize(w, h);
    this._scale = sH;

    this._update();
    this.app.instance.render();

    return this;
};

const _setLocalShift = function (value) {
    this._shift = value;
}

module.exports = el => {
    const wm = {
        el: el,
        g: el.querySelector('.wm__g'),
        svg: el.querySelector('svg')
    };

    wm.init = _init.bind(wm);
    wm.start = _start.bind(wm);
    wm.stop = _stop.bind(wm);
    wm.setLocalShift = _setLocalShift.bind(wm);
    wm._update = _update.bind(wm);
    wm._handleResize = _handleResize.bind(wm);

    return wm;
};


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/components/PIXIWatermark.js